// src
import * as styleVars from '@common/styles/constants'

import React from 'react'
import ReactDOMServer from 'react-dom/server'
import { classNames } from '@common/utils/helpers'
import styled from '@emotion/styled'

const SpinnerWrapper = styled.span<{
  color: string
  width: number
  height: number
  baseBorderSize: number
}>`
  @keyframes rotation {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
  width: ${(props) => props.width}px;
  height: ${(props) => props.height}px;
  border-radius: 50%;
  display: inline-block;
  border-top: ${(props) => props.baseBorderSize}px solid
    ${(props) => props.color};
  border-right: ${(props) => props.baseBorderSize + 1}px solid
    ${(props) => props.color};
  border-bottom: ${(props) => props.baseBorderSize + 2}px solid
    ${(props) => props.color};
  border-left: ${(props) => props.baseBorderSize + 3}px solid transparent;
  box-sizing: border-box;
  animation: rotation 1s linear infinite;
`
interface SpinnerProps {
  color?: string
  widthAndHeight?: number
  className?: string
}
const Spinner: React.FC<React.PropsWithChildren<SpinnerProps>> = (props) => {
  const {
    className = '',
    color = styleVars.primaryBlue,
    widthAndHeight = 12,
  } = props

  const classes = classNames('pq-spinner', className)

  return (
    <SpinnerWrapper
      data-cy="pq-spinner"
      className={classes}
      color={color}
      baseBorderSize={1}
      width={widthAndHeight}
      height={widthAndHeight}
    />
  )
}

export const getSpinnerHtml = (props) => {
  return ReactDOMServer.renderToString(<Spinner {...props} />)
}

export default Spinner
